import axiosInstance from "./config";

const ROUTE = "/account";

export const fetchUser = () =>
  axiosInstance.get(`${ROUTE}/user/`).then((response) => response.data);

export const registerUserRequest = (requestData) =>
  axiosInstance
    .post(`${ROUTE}/register-team-admin-and-client/`, requestData)
    .then((response) => response.data);
